import React, { FunctionComponent } from 'react';
import CheckboxWithLabel from 'app/components/presentation/forms/CheckboxWithLabel';
import Checkbox from 'app/components/presentation/forms/Checkbox';
import {
  useDeviceManager,
  useDeviceManagerState,
  useIsDeviceManagerBusy,
} from 'app/containers/rtc/DeviceManagerContext';
import { useI18n } from 'app/components/localization';
import MediaDevices from 'app/services/rtc/MediaDevices';
import { WebRTCFeatures } from 'app/services/rtc/constants';

const AutoGainCheckbox: FunctionComponent = () => {
  const deviceManager = useDeviceManager();
  const devices = useDeviceManagerState();
  const isBusy = useIsDeviceManagerBusy();
  const { t } = useI18n();

  if (
    !deviceManager ||
    !devices ||
    !MediaDevices.getSupportedFeatures().has(WebRTCFeatures.AutoGain)
  ) {
    return null;
  }

  return (
    <CheckboxWithLabel
      checkbox={
        <Checkbox
          checked={devices.audio.autoGain}
          onToggle={deviceManager.setAutoGain}
          disabled={isBusy}
        />
      }
    >
      {t('rtc.device-setup.settings.audio.autogain')}
    </CheckboxWithLabel>
  );
};

export default AutoGainCheckbox;
